import { render } from "./EditBookable.vue?vue&type=template&id=d4331222&scoped=true"
import script from "./EditBookable.vue?vue&type=script&lang=js"
export * from "./EditBookable.vue?vue&type=script&lang=js"

import "./EditBookable.vue?vue&type=style&index=0&id=d4331222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4331222"]])

export default __exports__